module.exports = __webpack_public_path__ + "static/img/BU01PB.c01c4e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/BU01PB.jpg
// module id = kuV0
// module chunks = 1